import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import { optionalAttribute } from 'utils/jsx';

import { Icon } from 'sheets';

import styles from './VideoPlayButton.css';
const cx = classNames.bind(styles);

class VideoPlayButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const containerClass = optionalAttribute(`className`, this.props.className, this.props.className);
    const buttonClass = cx(`play-button`, {
      'play-button--blue': this.props.color === `blue`,
    });
    const iconClass = cx(`play-icon`, {
      'play-icon--white': this.props.color === `blue`,
    });

    return (
      <div {...containerClass}>
        <button
          className={buttonClass}
          onClick={this.props.handleVideoPlay}
        >
          <Icon
            className={iconClass}
            name="play-button-outline"
          />
        </button>
      </div>
    );
  }
}

VideoPlayButton.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    `blue`,
    `gray`,
  ]),
  handleVideoPlay: PropTypes.func.isRequired,
};

export default VideoPlayButton;
